/*!

=========================================================
* Argon Dashboard PRO React Nodejs - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react-nodejs
* Copyright 2021 Creative Tim (http://www.creative-tim.com)

* Coded by Creative Tim
* Coded by ProjectData

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

const config = {
    WS_BASE_URL: 'https://us-central1-livelock-92cfa.cloudfunctions.net/api/api/', // change here for https backend
    DOMAIN_NAME: 'dashboard.livelock.app',
    DEMO: false
}

export default config;
